//==============================================
// Utilites
//==============================================


// iFrame Moblie Resising 
export let iframeResise = () => {
	var mobileWidth = $(window).width();
	if(mobileWidth < 600){
		$('.video_iframe').attr('height', '200px');
	}
}

